export const pad = (n) => String(n).padStart(2, '0')
export const fmtDate = (d) => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`
export const fmtLocalDT = (d) => `${fmtDate(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`